import {Action} from '@ngrx/store';
import {VorlagenMandantOptions} from '../../../clients/vorlagen';
import {MandantStammOptions} from '../../../clients/api';
import {IncidentsAnzeigeMandantOptions} from '../../../clients/incidents';
import {PandemieMandantOptions} from '../../../clients/pandemie';

export const PAGE_STATE_RESET = '[MandantenverwaltungPage] Page State reset';

export const STAMM_CONFIG_INPUT = '[MandantenverwaltungPage] Stamm Config Eingabe';
export const VORLAGEN_CONFIG_INPUT = '[MandantenverwaltungPage] Vorlagen Config Eingabe';
export const INCIDENT_ANZEIGE_CONFIG_INPUT = '[MandantenverwaltungPage] Incident Anzeige Config Eingabe';
export const MANDANTEN_EINSTELLUNGEN_SPEICHERN = '[MandantenverwaltungPage] Mandanten Einstellungen Speichern';

export const MANDANTEN_KONFIGURATION_SPEICHERN = '[MandantenverwaltungPage] Mandanten Konfiguration Speichern';
export const PANDEMIE_CONFIG_INPUT = '[MandantenverwaltungPage] Pandemie Config Eingabe';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// Mandanten Einstellungen
export class StammConfigInput implements Action {
    readonly type = STAMM_CONFIG_INPUT;

    constructor(public payload: MandantStammOptions) {}
}
export class VorlagenConfigInput implements Action {
    readonly type = VORLAGEN_CONFIG_INPUT;

    constructor(public payload: VorlagenMandantOptions) {}
}
export class IncidentAnzeigeConfigInput implements Action {
    readonly type = INCIDENT_ANZEIGE_CONFIG_INPUT;

    constructor(public payload: IncidentsAnzeigeMandantOptions) {}
}

export class MandantenEinstellungenSpeichern implements Action {
    readonly type = MANDANTEN_EINSTELLUNGEN_SPEICHERN;

    constructor() {}
}

export class MandantenKonfigurationSpeichern implements Action {
    readonly type = MANDANTEN_KONFIGURATION_SPEICHERN;

    constructor() {}
}


export class PandemieConfigInput implements Action {
    readonly type = PANDEMIE_CONFIG_INPUT;

    constructor(public payload: PandemieMandantOptions) {}
}


export type Actions =
    | PageStateResetAction
    | StammConfigInput
    | VorlagenConfigInput
    | IncidentAnzeigeConfigInput
    | MandantenEinstellungenSpeichern
    | MandantenKonfigurationSpeichern
    | PandemieConfigInput
    ;
